import { Actor } from "../actor.js";
import { Layer } from "../tile.js";
import { actorDB } from "../const.js";
import { Water, Dirt, Ice } from "./terrain.js";
export class DirtBlock extends Actor {
    constructor() {
        super(...arguments);
        this.id = "dirtBlock";
        this.transmogrifierTarget = "iceBlock";
    }
    getLayer() {
        return Layer.MOVABLE;
    }
    blocks() {
        return true;
    }
    bumpedActor(other) {
        if (other.hasTag("real-playable") &&
            !this.hasTag("ignore-default-monster-kill") &&
            !other.hasTag("ignore-default-monster-kill"))
            other.destroy(this);
    }
    newTileCompletelyJoined() {
        const water = this.tile[Layer.STATIONARY];
        if (!(water === null || water === void 0 ? void 0 : water.hasTag("water")))
            return;
        if (!water._internalIgnores(this)) {
            this.destroy(this, "splash");
            water.destroy(null, null);
            new Dirt(this.level, this.tile.position);
        }
    }
}
DirtBlock.tags = ["block", "cc1block", "movable", "reverse-on-railroad"];
DirtBlock.ignoreTags = ["fire"];
DirtBlock.immuneTags = ["water"];
actorDB["dirtBlock"] = DirtBlock;
export class IceBlock extends Actor {
    constructor() {
        super(...arguments);
        this.id = "iceBlock";
        this.transmogrifierTarget = "dirtBlock";
    }
    getLayer() {
        return Layer.MOVABLE;
    }
    blocks() {
        return true;
    }
    bumpedActor(other) {
        if (other.hasTag("real-playable") &&
            !this.hasTag("ignore-default-monster-kill") &&
            !other.hasTag("ignore-default-monster-kill"))
            other.destroy(this);
    }
    newTileCompletelyJoined() {
        const terrain = this.tile[Layer.STATIONARY];
        if ((terrain === null || terrain === void 0 ? void 0 : terrain.hasTag("water")) && !terrain._internalIgnores(this)) {
            this.destroy(this, "splash");
            terrain.destroy(null, null);
            new Ice(this.level, this.tile.position);
        }
        if ((terrain === null || terrain === void 0 ? void 0 : terrain.hasTag("melting")) && !terrain._internalIgnores(this)) {
            this.destroy(this, "splash");
            terrain.destroy(null, null);
            new Water(this.level, this.tile.position);
        }
    }
    bumped(other) {
        if (other.hasTag("melting") &&
            (!this.tile.hasLayer(Layer.STATIONARY) ||
                this.tile[Layer.STATIONARY].id === "water")) {
            this.destroy(this, "splash");
            if (!this.tile.hasLayer(Layer.STATIONARY))
                new Water(this.level, this.tile.position);
        }
    }
    canBePushed(other) {
        // Fun fact: Ice blocks & dir blocks just can't be pushed when they are sliding and a block is pushing them
        return !(this.slidingState && other.hasTag("block"));
    }
}
IceBlock.pushTags = ["cc2block"];
IceBlock.tags = [
    "block",
    "cc2block",
    "movable",
    "can-stand-on-items",
    "meltable-block",
    "reverse-on-railroad",
];
IceBlock.immuneTags = ["water"];
actorDB["iceBlock"] = IceBlock;
export class DirectionalBlock extends Actor {
    constructor() {
        super(...arguments);
        this.id = "directionalBlock";
        this.legalDirections = Array.from(this.customData).map(val => "URDL".indexOf(val));
    }
    getLayer() {
        return Layer.MOVABLE;
    }
    blocks() {
        return true;
    }
    bumpedActor(other) {
        if (other.hasTag("real-playable") &&
            !this.hasTag("ignore-default-monster-kill") &&
            !other.hasTag("ignore-default-monster-kill"))
            other.destroy(this);
    }
    newTileCompletelyJoined() {
        const water = this.tile[Layer.STATIONARY];
        if ((water === null || water === void 0 ? void 0 : water.hasTag("water")) && !water._internalIgnores(this)) {
            water.destroy(null, null);
            this.destroy(this, "splash");
        }
    }
    canBePushed(other, direction) {
        if (!this.legalDirections.includes(direction))
            return false;
        // Fun fact: Ice blocks & dir blocks just can't be pushed when they are sliding and a block is pushing them
        return !(this.slidingState && other.hasTag("block"));
    }
    rebuildCustomData() {
        this.customData = "";
        for (const dir of this.legalDirections) {
            this.customData += "URDL"[dir];
        }
    }
    onRedirect(delta) {
        for (let i = 0; i < this.legalDirections.length; i++) {
            this.legalDirections[i] = (this.legalDirections[i] - delta + 4) % 4;
        }
        this.rebuildCustomData();
    }
}
DirectionalBlock.pushTags = ["block"];
DirectionalBlock.tags = [
    "block",
    "cc2block",
    "movable",
    "can-stand-on-items",
    "reverse-on-railroad",
    "dies-in-slime",
];
DirectionalBlock.immuneTags = ["water"];
actorDB["directionalBlock"] = DirectionalBlock;
//# sourceMappingURL=blocks.js.map